module.exports = __webpack_public_path__ + "static/media/w5.3caa8790.png";